import { render, staticRenderFns } from "./ActBaseBottom.vue?vue&type=template&id=c6167044&scoped=true&"
import script from "./ActBaseBottom.vue?vue&type=script&lang=js&"
export * from "./ActBaseBottom.vue?vue&type=script&lang=js&"
import style0 from "./ActBaseBottom.vue?vue&type=style&index=0&id=c6167044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6167044",
  null
  
)

export default component.exports